import { CONSTANTS } from '../config/constants';

export function formatAddress(addressFields: string[], address?: any) {
  const textAddress: string[] = [];

  addressFields.forEach((key: string) => {
    if (address && address[key]) {
      textAddress.push(address[key]);
    }
  });

  return textAddress.join(CONSTANTS.RENDERER_ARRAY_SEPARATOR);
}
